import React, {useContext} from "react";
import {useNavigate} from "react-router";
import styled from "styled-components";
import {SiteContext} from "../context/SiteContext";
import {getLogoURL} from "../util/logoUtils";
import Button from "./atoms/Buttons";


const CabecerawithNav = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin: 0;
  height: calc(20vh - 3rem);
  padding-top: 1rem;
  @media (max-height: 600px) {
    transition: all 0.5s ease;
    padding-top: 0rem;
    height: calc(20vh - 1rem);
  }
`
export const LogoImage = styled.img`
  height: calc(20vh - 4rem);
  cursor: pointer;
  transition: all 0.5s ease;
  @media (max-height: 600px) {
    transition: all 0.5s ease;
    padding-top: 0rem;
    height: calc(20vh - 3rem);
  }
`

const LogoCenter = ({mainview = true}) => {

  const navigate = useNavigate()
  const {info} = useContext(SiteContext)
  const logoUrl = info.sala.logo

  return (
    <CabecerawithNav>
      {mainview &&
        <Button onClick={() => navigate(-1)} style={{minWidth:"180px"}}>
          VOLVER
        </Button>
      }

      <LogoImage src={getLogoURL(logoUrl)} onClick={() => navigate("/selector")}/>

      {mainview &&
        <Button onClick={() => navigate("/sorteo-list")} style={{minWidth:"180px"}}>
          INICIO
        </Button>
      }
    </CabecerawithNav>
  )
}

export default LogoCenter
